import cmsPageRepository from '../repositories/cmsPageRepository';

const cmsPageService = {
  getCmsResult: async ({syncUpAppName,body}) => {
    return await cmsPageRepository.getCmsResult({syncUpAppName,body});
  },
};

export default cmsPageService;
